import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getNetworkMerchantStatus({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkMerchant.status, signal });
    yield put(actions.getNetworkMerchantStatusDone(data.result));
  } catch (error) {
    // 404 means this org hasn't connected Shopify to the affiliate network yet - an expected,
    // normal state, not an error. handleErrors treats 404 as critical (full-page error), so
    // it's handled here instead of falling through to it.
    if (error.response?.status === 404) {
      yield put(actions.getNetworkMerchantStatusNotConnected());
      return;
    }

    yield handleErrors({
      error,
      putErrorData: actions.getNetworkMerchantStatusFailed,
      endpoint: api.networkMerchant.status.url
    });
  }
}

function* setNetworkMerchantRate({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkMerchant.rate, data: values });
    onSuccess && onSuccess();
    yield put(actions.setNetworkMerchantRateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.setNetworkMerchantRateFailed,
      handledErrors,
      endpoint: api.networkMerchant.rate.url
    });
  }
}

function* setNetworkMerchantLockingWindow({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkMerchant.locking_window, data: values });
    onSuccess && onSuccess();
    yield put(actions.setNetworkMerchantLockingWindowDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.setNetworkMerchantLockingWindowFailed,
      handledErrors,
      endpoint: api.networkMerchant.locking_window.url
    });
  }
}

function* requestNetworkActivation({ payload: { onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkMerchant.request_activation });
    onSuccess && onSuccess();
    yield put(actions.requestNetworkActivationDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.requestNetworkActivationFailed,
      endpoint: api.networkMerchant.request_activation.url
    });
  }
}

export const getNetworkMerchantStatusSaga = takeEvery(types.GET_NETWORK_MERCHANT_STATUS_REQUEST, getNetworkMerchantStatus);
export const setNetworkMerchantRateSaga = takeEvery(types.SET_NETWORK_MERCHANT_RATE_REQUEST, setNetworkMerchantRate);
export const setNetworkMerchantLockingWindowSaga = takeEvery(
  types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_REQUEST,
  setNetworkMerchantLockingWindow
);
export const requestNetworkActivationSaga = takeEvery(types.REQUEST_NETWORK_ACTIVATION_REQUEST, requestNetworkActivation);
